const state = {
	status: 0,
	loading: false,
	firstLoad: false,
	campaign: {}
}

const getters = {
	notLoaded: s => s.status === 0 && !s.loading,
	pending: s => s.status === 0,
	loaded: s => s.status === 200,
	notFound: s => s.status === 404,
	allowVoting: s => s.campaign.allowVoting || false
}

const mutations = {
	setLoading(state, loading) {
		state.loading = loading
	},
	setStatus(state, status) {
		state.status = status
	},
	setCampaign(state, campaign) {
		state.campaign = campaign
		if (!state.firstLoad) state.firstLoad = true
	}
}

const actions = {
	async load({ dispatch, commit }) {
		const setLoading = value => commit('setLoading', value)
		const setStatus = value => commit('setStatus', value)
		const setCampaign = value => commit('setCampaign', value)

		// Set status to loading
		setLoading(true)
		setStatus(0)

		try {
			// Get active campaign
			const endpoint = '/campaigns/active'
			const res = await dispatch('api/get', { endpoint }, { root: true })
			const campaign = await res.json()
			setStatus(res.status)
			setCampaign(campaign)
		} catch (err) {
			setStatus(err.status || 500)
			setCampaign({})
		}

		// Finish loading
		setLoading(false)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
